import { getTop100Items } from "@galarson/Handlers/Top100Items/Top100ItemsService";
import { Top100ItemsTypes } from "@galarson/Store/Top100Items/Top100ItemsState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";


type HandlerType = Handler<{
    customerNumber: string;
    sort: string;
}>;

export const DispatchBeginExportOrders: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderHistory/BeginExportOrders",
    });
};

export const ExportData: HandlerType = async props => {
    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");

    const data: any[] = [];
    const state = props.getState();
    const language = state.context.session.language;
    const top100Items = (items: any) => {
        return [
            items.description,
            items.supplierName,
            items.erpProductNumber,
            items.quantityBought,
            items.customerPartNumber,
            items.timesOrdered,
        ];
    };
        const top100ItemsResult = await getTop100Items({
            sort:props.parameter.sort,customerNumber:props.parameter.customerNumber
        });
        if (top100ItemsResult && top100ItemsResult?.top100Items) {
            top100ItemsResult?.top100Items?.forEach(item => {
                data.push(top100Items(item));
            });
        }
    
    const documentData = {
        fields: [
            translate("Description"),
            translate("Vendor"),
            translate("Item #"),
            translate("Qty Ordered"),
            translate("Customer Part #"),
            translate("Times Ordered ")
        ],
        data,
    };

    const csv = unparse(documentData);

    let csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });
    

    const fileName = `Top100Items.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
};

export const DispatchCompleteExportOrders: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderHistory/CompleteExportOrders",
    });
};

export const chain = [DispatchBeginExportOrders, ExportData, DispatchCompleteExportOrders];

const ExportTop100Items = createHandlerChainRunner(chain, "ExportTop100Items");
export default ExportTop100Items;
